var BankAccountType;
(function (BankAccountType) {
  BankAccountType[BankAccountType["TYPE_CHECKING"] = 1] = "TYPE_CHECKING";
  BankAccountType[BankAccountType["TYPE_SAVING"] = 2] = "TYPE_SAVING";
})(BankAccountType || (BankAccountType = {}));
var DocumentType;
(function (DocumentType) {
  DocumentType[DocumentType["CNPJ"] = 1] = "CNPJ";
  DocumentType[DocumentType["CPF"] = 2] = "CPF";
})(DocumentType || (DocumentType = {}));

export { BankAccountType, DocumentType };
